import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo.png'; // Adjust the path based on your structure

const Header = () => {
  return (
    <>
      <header className="site-header">
        <div className="logo-container">
          <Link to="/about" aria-label="Spatial Reminders home">
            <img src={logo} alt="Spatial Reminders Logo" className="logo" />
          </Link>
        </div>
        <div className="download-container">
          <a
            href="https://apps.apple.com/app/spatial-reminders/id6502372575"
            className="sr-button sr-button--primary sr-button--compact header-cta"
          >
            Download Spatial Reminders
          </a>
        </div>
      </header>
    </>
  );
};

export default Header;
